import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";

const GraficaSegmentacionNegativeChart = ({ segmentationData = {} }) => {
  const [chartData, setChartData] = useState({
    series: [],
    options: {
      chart: {
        type: "bar",
        height: 440,
        stacked: true,
        toolbar: {
          show: false, // Oculta la barra de herramientas, incluido el menú de descarga
        },
      },
      colors: ["#008FFB", "#FF4560"],
      plotOptions: {
        bar: {
          horizontal: true,
          barHeight: "90%",
        },
      },
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          return Math.abs(Math.round(val));
        },
        style: {
          fontSize: '13px',
          colors: ["#fff"],
        }
      },
      stroke: {
        width: 1,
        colors: ["#fff"],
      },
      grid: {
        xaxis: {
          lines: {
            show: false,
          },
        },
      },
      tooltip: {
        shared: false,
        x: {
          formatter: function (val) {
            return val;
          },
        },
        y: {
          formatter: function (val) {
            return Math.abs(val);
          },
        },
      },
      xaxis: {
        categories: [],
        labels: {
          formatter: function (val) {
            return Math.abs(Math.round(val));
          },
        },
      },
      legend: {
        show: true, // Esta línea oculta la leyenda del gráfico
        position: "top",
        horizontalAlign: "right",
        markers: {
          width: 12,
          height: 12,
          radius: 12,
        },
      },
    },
  });

  useEffect(() => {
    if (segmentationData.seriesData && segmentationData.categories) {
      const filteredSeriesData = segmentationData.seriesData.filter(
        (series) => {
          return series.data.some((value) => value !== 0);
        }
      );

      let max = 0;
      filteredSeriesData.forEach((item) => {
        const itemMax = Math.max(...item.data);
        if (itemMax > max) {
          max = itemMax;
        }
      });

      max = Math.abs(max);

      setChartData((prev) => ({
        ...prev,
        series: filteredSeriesData,
        options: {
          ...prev.options,
          xaxis: {
            ...prev.options.xaxis,
            categories: segmentationData.categories,
            min: -max,
            max: max,
          },
        },
      }));
    }
  }, [segmentationData]);

  return (
    <div className="bg-white shadow-xl rounded-xl">
      <h2 className="p-2 mx-4 -my-4 text-xl font-bold text-left ">
        Grafica de Segmentación
      </h2>
      <div id="chart">
        <ReactApexChart
          options={chartData.options}
          series={chartData.series}
          type="bar"
          height={200}
        />
      </div>
    </div>
  );
};

export default GraficaSegmentacionNegativeChart;
